import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from "@mui/material";
export const UiDivider = (props) => _jsx(Divider, Object.assign({}, props));
//# sourceMappingURL=ui_divider.js.map